import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CatalogItem from "./CatalogItem";
import RequisitionAction from 'Store/Component/Requisition/RequisitionAction'
import { IManagedEquipment } from "Model/IManagedEquipment";
import { IRequest } from "Model/IRequest";
import { IReason } from "Model/IReason";
import { initializeReason } from "client/utils/RequisitionUtil";
import ConfirmationBee from "../../../../assets/images/ConfirmationBee.svg";
import { CONSTANTS } from "client/utils/constants";
import { popupInitialData } from "utils";

const CatalogItemContainer = (props: any) => {
  const dispatch = useDispatch();
  const cloneDeep = <T,>(value: T): T => (value === undefined || value === null ? value : JSON.parse(JSON.stringify(value)));

 
  const [catalogItemDetailsTemp, setCatalogItemDetailsTemp] = useState<any>([]);

  const [Popupcontent, setPopupcontent] = useState<any>(popupInitialData);

  const { selectedRequisitionType, managedEquipmentList, managedEquipmentValues, selectedEquipmentType, catalogItem, requestList, reasonList, selectedCatalogItem, isCatalogItemExist, editRequestDetails, isEditRequestClick, isDealerSameForAllFlag }: any = useSelector((state?: any) => ({
    selectedRequisitionType: state.RequisitionReducer.selectedRequisitionType,
    managedEquipmentList: state.RequisitionReducer.managedEquipmentList,
    managedEquipmentValues: state.RequisitionReducer.managedEquipmentValues,
    selectedEquipmentType: state.RequisitionReducer.selectedEquipmentType,
    catalogItem: state.CatalogItemReducer.catalogItem,
    requestList: state.RequisitionReducer.requestList,
    reasonList: state.RequisitionReducer.reasonList,
    selectedCatalogItem: state.RequisitionReducer.selectedCatalogItem,
    isCatalogItemExist : state.RequisitionReducer.isCatalogItemExist,
    editRequestDetails: state.RequisitionReducer.editRequestDetails,
    isEditRequestClick: state.RequisitionReducer.isEditRequestClick,
    isDealerSameForAllFlag : state.RequisitionReducer.isDealerSameForAllFlag
  }));

  useEffect(() => {
    let catalogList = Array.isArray(catalogItem) ? cloneDeep(catalogItem) ?? [] : []
    let managedEquipmentItem = managedEquipmentList?.length > 0 ? (cloneDeep(managedEquipmentList) ?? []).map((i:any) => i.assetModelId) : []
    if(managedEquipmentItem?.length >0){
      catalogList = catalogList.map((val:any)=>{
        if(managedEquipmentItem?.includes(val?.assetModelId)){
            val.isDisable = false
            val.isSelected = true
        } else (
          val.isSelected = false
        )
    })
      dispatch(RequisitionAction.setSelectedCatalogItem(catalogList))
    }
    else{
      dispatch(RequisitionAction.setSelectedCatalogItem(cloneDeep(catalogItem)))
    }
  }, [catalogItem, isEditRequestClick])

  useEffect(() => {    
    setCatalogItemDetailsTemp(cloneDeep(selectedCatalogItem) ?? [])
  }, [selectedCatalogItem])

  useEffect(() => {
    if (editRequestDetails?.assetModelId && Array.isArray(catalogItem) && catalogItem.length > 0) {
      const catalogItemDetailsTemp = (cloneDeep(catalogItem) ?? []).map((element: any) => {
        if (element?.assetModelId === editRequestDetails?.assetModelId) {
          element.isSelected = true;
        } else {
          element.isSelected = false;
        }
        return element
      });
      dispatch(RequisitionAction.setSelectedCatalogItem(catalogItemDetailsTemp))
    }
  }, [editRequestDetails?.assetModelId, catalogItem])

  const quantityIncrement = (e: any, item: any) => {
    e.stopPropagation();
    const updatedCatalogItems = cloneDeep(catalogItemDetailsTemp) ?? [];
    updatedCatalogItems.map((element: any) => {
      if (element.assetModelId === item.assetModelId) {
        let qtyVal = element?.quantity != undefined ? parseInt(element?.quantity) : element?.quantity
        if (qtyVal  == undefined) {
          qtyVal  = 1;
        }
        element.quantity = qtyVal + 1;
      }
    })
    dispatch(RequisitionAction.setSelectedCatalogItem(updatedCatalogItems))
  }

  const quantityDecrement = (e: any, item: any) => {
    e.stopPropagation();
    const updatedCatalogItems = cloneDeep(catalogItemDetailsTemp) ?? [];
    updatedCatalogItems.map((element: any) => {
      if (element.assetModelId === item.assetModelId) {
          let qtyVal = element?.quantity != undefined ? parseInt(element?.quantity) : element?.quantity
          if (qtyVal  == undefined) {
            qtyVal  = 1;
          }
          element.quantity = qtyVal - 1;
      }
    })
    dispatch(RequisitionAction.setSelectedCatalogItem(updatedCatalogItems))
  }
  const isValidateQty = (qty :any) => {
    let error="";
    if (qty === "" || qty === 0 || qty === undefined) {
       error ="Please enter valid quantity";
    }
    return error;
  }

  const quantityOnChange = (e: any, item: any) => {
    e.stopPropagation();
    const updatedCatalogItems = cloneDeep(catalogItemDetailsTemp) ?? [];
    updatedCatalogItems.map((element: any) => {
      if (element.assetModelId === item.assetModelId) {
        let qtyVal = element?.quantity != undefined ? parseInt(element?.quantity) : element?.quantity;
        let error=isValidateQty(e.target.value);
        element.quantityerror=error;
        if (isNaN(e.target.value.toString()) || parseInt(e.target.value) <= 0) {
          qtyVal = 1;
          element.quantity=qtyVal;
        }else{
          qtyVal = e.target.value;
          element.quantity=qtyVal;
        }
      }
    });
    dispatch(RequisitionAction.setSelectedCatalogItem(updatedCatalogItems))
  }
  const handleCardClick = (item: any) => {    
    
    const updatedCatalogItems = cloneDeep(catalogItemDetailsTemp) ?? [];
    updatedCatalogItems.map((element: any) => {
      
      if(isEditRequestClick){
        if(element?.assetModelId === item?.assetModelId){
          element.isSelected = true
        } else {
          element.isSelected = false
        }
      }else if (element?.assetModelId == item.assetModelId) {
          let isItemSelected
        ///This condition is to restrict deselecting the catalog item after adding
        let isItemExists = false;
          if (Array.isArray(managedEquipmentList) && managedEquipmentList.length > 0) {
            managedEquipmentList.map((managedItem?: any, _index?: any) => {
              if (managedItem.assetModelId == element.assetModelId) {
                isItemExists = true;
                return
              }
            })
          }
          if(!isItemExists){
            if (element?.isSelected == undefined || element?.isSelected == false) {
              isItemSelected = true;
            } else {
              isItemSelected = false;
            }
            element.isSelected = isItemSelected;
          }
      }
    });
    // setCatalogItemDetails(catalogItemDetails)
    dispatch(RequisitionAction.setSelectedCatalogItem(updatedCatalogItems))
  }

  const addNewItemClick = () => {
    let showItemDetail = false;
    let checkQuntity=false;
    const catalogItemDetailsTempClone = Array.isArray(catalogItemDetailsTemp) ? cloneDeep(catalogItemDetailsTemp) ?? [] : [];
    catalogItemDetailsTempClone?.map((item?: any, _index?: any) => {
      if (item?.isSelected == true && item.quantityerror)
      {
        if(item.quantityerror  !== "")
        {   
          let decriptionTxt = (
            <p>Please Enter Quantity.</p>
          );
          setPopupcontent({
            ...Popupcontent,
            titleImg: ConfirmationBee,
            title: "INFORMATION",
            isDialogVisible: true,
            isTitleWarning: false,
            subtextcontent: decriptionTxt,
            outlineBtnText: "Ok",
            popupOutlinebtnOnclick: popupOutlinebtnOnclick,
            isSingleConfirmationBtn: true,
          });
          checkQuntity=true; 
        }
      }
    })
    if(!checkQuntity)
    {
      catalogItemDetailsTempClone?.map((item?: any, _index?: any) => {
        if (item?.isSelected == true) {
          showItemDetail = true;
          item.isDisable = true;
          return
        }
      })
      dispatch(RequisitionAction.setSelectedCatalogItem(catalogItemDetailsTempClone));
    if (showItemDetail) {
      dispatch(RequisitionAction.setIsChangesOccured(true))
    const ManagedEquipmentListTemp = Array.isArray(managedEquipmentList) ? cloneDeep(managedEquipmentList) ?? [] : [];
    const requestListTemp = Array.isArray(requestList) ? cloneDeep(requestList) ?? [] : [];
    const reasonListTemp = Array.isArray(reasonList) ? cloneDeep(reasonList) ?? [] : [];
      let nonDuplicatedItemCount = 0;
      Array.isArray(catalogItemDetailsTemp) && catalogItemDetailsTemp.map((item?: any, _index?: any) => {
        if (item?.isSelected) {
          let isDuplicated = false;
          if (Array.isArray(managedEquipmentList) && managedEquipmentList.length > 0) {
            managedEquipmentList.map((managedItem?: any, _index?: any) => {
              if (managedItem.assetModelId == item.assetModelId) {
                isDuplicated = true;
                return
              }
            })
          }
          if (!isDuplicated) {
            nonDuplicatedItemCount = nonDuplicatedItemCount + 1
            const managedEquipment: IManagedEquipment = {
              requestIndex: 0,
              requestType: "",
              requestId: 0,
              managedEquipmentIndex: 0,
              orderTypeId: selectedRequisitionType?.orderRequestTypeId,
              orderSubTypeId: selectedEquipmentType?.value,
              equipmentType: selectedEquipmentType?.label,
              stateAvailability: managedEquipmentValues?.stateAvailability?.value,
              manufacturer: managedEquipmentValues?.manufacturer?.value,
              programStatus: managedEquipmentValues?.programStatus?.value,
              annualHours: managedEquipmentValues?.annualHours?.value,
              category: managedEquipmentValues?.category?.value,
              deckSize: managedEquipmentValues?.deckSize?.value,
              deckType: managedEquipmentValues?.deckType?.value,
              autonomous: managedEquipmentValues?.autonomous?.value,
              seatingCapacity: managedEquipmentValues?.seatingCapacity?.value,
              enclosedCab: managedEquipmentValues?.enclosedCab?.value,
              capacity: managedEquipmentValues?.capacity?.value,
              style: managedEquipmentValues?.style?.value,
              length: managedEquipmentValues?.length?.value,
              fuelTank: managedEquipmentValues?.fuelTank?.value,
              chargingStation: managedEquipmentValues?.chargingStation?.value,
              size: managedEquipmentValues?.size?.value,
              type: managedEquipmentValues?.type?.value,
              treeCareEquipmentType: managedEquipmentValues?.treeCareEquipmentType?.value,
              horsePower: managedEquipmentValues?.horsePower?.value,
              fuelType: managedEquipmentValues?.fuelType?.value,
              isExistInCart: false,

              assetModelId: item?.assetModelId,
              make: item?.make,
              model: item?.model,
              year: item?.year,
              monthlyExpense: item?.monthlyExpense,
              description: item?.description,
              podesc1: item?.podesc1,
              podesc2: item?.podesc2,
              design: item?.design,
              driverTitle: item?.driverTitle,
              price: item?.price,
              quantity: item?.quantity,
              showQuotePrice: item?.price ? false : true
            };
            //Request
            let nextRequestIndex = 0;
            requestListTemp.forEach((item : any) => {
              if (item?.requestIndex > nextRequestIndex) {
                nextRequestIndex = item?.requestIndex;
              }
            });
            nextRequestIndex = nextRequestIndex + 1;

            const request: IRequest = {
              requestIndex: nextRequestIndex,
              requestType: selectedRequisitionType.orderRequestType,
              showQuotePrice: item?.price == 0 ? true : false
            };
            requestListTemp.push(request);

            //Production Vehicle
            let nextManagedEquimentIndex = 0;
            ManagedEquipmentListTemp.forEach((item : any) => {
              if (item.managedEquipmentIndex > nextManagedEquimentIndex) {
                nextManagedEquimentIndex = item.managedEquipmentIndex;
              }
            });
            nextManagedEquimentIndex = nextManagedEquimentIndex + 1;

            //set the index
            managedEquipment.requestIndex = request?.requestIndex;
            managedEquipment.requestType = request?.requestType;
            managedEquipment.managedEquipmentIndex = nextManagedEquimentIndex;

            ManagedEquipmentListTemp.push(managedEquipment);
            //Reason
            let nextReasonIndex = 0;
            reasonListTemp?.forEach((reasonitem : any) => {
              if (reasonitem?.reasonIndex > nextReasonIndex) {
                nextReasonIndex = reasonitem?.reasonIndex;
              }
            });

            let itemQuantity = item?.quantity == undefined ? 1 : item.quantity
            for (let i = 1; i <= itemQuantity; i++) {

              nextReasonIndex = nextReasonIndex + 1;

              const reason: IReason = initializeReason(request, nextReasonIndex);
              if(isDealerSameForAllFlag && reasonList?.length > 0){
                const managedEquipmentReasons = reasonList?.filter(
                  (r: any) => r?.requestType === CONSTANTS.MANAGED_EQUIPMENT
                );
              
                const firstManagedEquipmentReason = managedEquipmentReasons[0];

                reason.isDisabled= true
                reason.name = firstManagedEquipmentReason?.name
                reason.contact= firstManagedEquipmentReason?.contact
                reason.phone = firstManagedEquipmentReason?.phone
                reason.email= firstManagedEquipmentReason?.email
                reason.addressLine1 = firstManagedEquipmentReason?.addressLine1
                reason.addressLine2 = firstManagedEquipmentReason?.addressLine2
                reason.addressLine3 = firstManagedEquipmentReason?.addressLine3
                reason.city = firstManagedEquipmentReason?.city
                reason.state = firstManagedEquipmentReason?.state
                reason.zipCode = firstManagedEquipmentReason?.zipCode
              }
              reasonListTemp.push(reason);
            }
          }
        }
      })
      let isSelectedEquipment = false
      if(Array.isArray(managedEquipmentList) && managedEquipmentList.length > 0){
        managedEquipmentList.map((item:any)=>{
          if (item?.equipmentType === selectedEquipmentType?.label){
            isSelectedEquipment = true
          }
        })
      }
      if(isSelectedEquipment){
      if(nonDuplicatedItemCount > 0){
            let decriptionTxt = (
              <p>Newly selected catalog item has been added successfully.
                Please increase the quantity in item details if required.
              </p>
              
            );
            setPopupcontent({
              ...Popupcontent,
              titleImg: ConfirmationBee,
              title: "INFORMATION",
              isDialogVisible: true,
              isTitleWarning: false,
              subtextcontent: decriptionTxt,
              outlineBtnText: "Ok",
              popupOutlinebtnOnclick: popupOutlinebtnOnclick,
              isSingleConfirmationBtn: true,
            });
      }else {
            let decriptionTxt = (
              <p>Catalog item has been already selected.</p>
            );
            setPopupcontent({
              ...Popupcontent,
              titleImg: ConfirmationBee,
              title: "INFORMATION",
              isDialogVisible: true,
              isTitleWarning: false,
              subtextcontent: decriptionTxt,
              outlineBtnText: "Ok",
              popupOutlinebtnOnclick: popupOutlinebtnOnclick,
              isSingleConfirmationBtn: true,
            });
          } 
        }
      dispatch(RequisitionAction.setIRequest(requestListTemp))
      dispatch(RequisitionAction.setIManagedEquipment(ManagedEquipmentListTemp))
      dispatch(RequisitionAction.setIReason(reasonListTemp))
      dispatch(RequisitionAction.setShowItemDetails(true))
    } else {
      let decriptionTxt = (
        <p>Please Select atleast one catalog item to add.</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });
    }   
    }
  }

  const updateItemClick = () => {
    dispatch(RequisitionAction.setIsChangesOccured(true))
      const ManagedEquipmentListTemp = cloneDeep(managedEquipmentList) ?? [];
      const reasonListTemp = cloneDeep(reasonList) ?? [];
      let nonDuplicatedItemCount = 0;
      Array.isArray(catalogItemDetailsTemp) && catalogItemDetailsTemp.map((item?: any, _index?: any) => {
        if (item?.isSelected) {
          let isDuplicated = false;
          if (managedEquipmentList?.length > 0) {
            Array.isArray(managedEquipmentList) && managedEquipmentList.map((managedItem?: any, _index?: any) => {
              if (managedItem.assetModelId == item.assetModelId) {
                isDuplicated = true;
                return
              }
            })
          }

          if (!isDuplicated) {

            const getRequestPrice = () => {
              if (item?.price > 0) {
                return item?.price
              } else {
                const price = reasonListTemp.reduce((acc: any, reason: any) => {
                  if (reason.requestIndex === editRequestDetails?.requestIndex) {
                    acc = acc + (parseFloat((reason.price || reason.estimatedPrice).split(',').join('')))
                  }
                  return acc
                }, 0)
                return price
              }
            }

            nonDuplicatedItemCount = nonDuplicatedItemCount + 1 
            ManagedEquipmentListTemp.forEach((equipment: any, index: any) => {
              if(equipment?.assetModelId === editRequestDetails?.assetModelId){
                ManagedEquipmentListTemp[index] = { 
                  ...equipment,
                  ...catalogItemDetailsTemp?.find((i: any) => i?.isSelected),
                  showQuotePrice: item?.price ? false : true,
                  price: getRequestPrice(),
                  orderTypeId: selectedRequisitionType?.orderRequestTypeId,
                  orderSubTypeId: selectedEquipmentType?.value,
                  equipmentType: selectedEquipmentType?.label,
                  stateAvailability: managedEquipmentValues?.stateAvailability?.value,
                  manufacturer: managedEquipmentValues?.manufacturer?.value,
                  programStatus: managedEquipmentValues?.programStatus?.value,
                  annualHours: managedEquipmentValues?.annualHours?.value,
                  category: managedEquipmentValues?.category?.value,
                  deckSize: managedEquipmentValues?.deckSize?.value,
                  deckType: managedEquipmentValues?.deckType?.value,
                  autonomous: managedEquipmentValues?.autonomous?.value,
                  seatingCapacity: managedEquipmentValues?.seatingCapacity?.value,
                  enclosedCab: managedEquipmentValues?.enclosedCab?.value,
                  capacity: managedEquipmentValues?.capacity?.value,
                  style: managedEquipmentValues?.style?.value,
                  length: managedEquipmentValues?.length?.value,
                  fuelTank: managedEquipmentValues?.fuelTank?.value,
                  chargingStation: managedEquipmentValues?.chargingStation?.value,
                  size: managedEquipmentValues?.size?.value,
                  type: managedEquipmentValues?.type?.value,
                  treeCareEquipmentType: managedEquipmentValues?.treeCareEquipmentType?.value,
                  horsePower: managedEquipmentValues?.horsePower?.value,
                  fuelType: managedEquipmentValues?.fuelType?.value,
                }
              }
            })
            reasonListTemp.forEach((reason:any, index:any) => {
              if(reason?.requestIndex === editRequestDetails?.requestIndex){
                reasonListTemp[index] = {
                   ...reason, 
                   showQuotePrice: item?.price ? false : true,
                   quotePrice: item?.price ? "" : reason?.quotePrice,
                   estimatedPrice: item?.price ? "" : reason?.estimatedPrice,
                   name: item?.price ? "" : reason?.name,
                   contact: item?.price ? "" : reason?.contact,
                   phone: item?.price ? "" : reason?.phone,
                   email: item?.price ? "" : reason?.email,
                   addressLine1: item?.price ? "" : reason?.addressLine1,
                   addressLine2: item?.price ? "" : reason?.addressLine2,
                   addressLine3: item?.price ? "" : reason?.addressLine3,
                   city: item?.price ? "" : reason?.city,
                   state: item?.price ? "" : reason?.state,
                   zipCode: item?.price ? "" : reason?.zipCode
                  }
              }
            })
          }
        }
      })

      let isSelectedEquipment = false
      if(Array.isArray(catalogItemDetailsTemp) && catalogItemDetailsTemp.length > 0){
        catalogItemDetailsTemp.map((item:any)=>{
          if (item?.isSelected){
            isSelectedEquipment = true
          }
        })
      }
      if(isSelectedEquipment){
      if(nonDuplicatedItemCount > 0){
            let decriptionTxt = (
              <p>Newly selected catalog item has been updated successfully.</p>
              
            );
            setPopupcontent({
              ...Popupcontent,
              titleImg: ConfirmationBee,
              title: "INFORMATION",
              isDialogVisible: true,
              isTitleWarning: false,
              subtextcontent: decriptionTxt,
              outlineBtnText: "Ok",
              popupOutlinebtnOnclick: popupOutlinebtnOnclick,
              isSingleConfirmationBtn: true,
            });
            dispatch(RequisitionAction.setIManagedEquipment(ManagedEquipmentListTemp))
            dispatch(RequisitionAction.setIReason(reasonListTemp))
            dispatch(RequisitionAction.setIsEditRequestClick(false))
            dispatch(RequisitionAction.setEditRequestDetails({}))
            // dispatch(RequisitionAction.setIsAddRequistionTypeClick(true))
      }else {
            let decriptionTxt = (
              <p>Catalog item has been already selected.</p>
            );
            setPopupcontent({
              ...Popupcontent,
              titleImg: ConfirmationBee,
              title: "INFORMATION",
              isDialogVisible: true,
              isTitleWarning: false,
              subtextcontent: decriptionTxt,
              outlineBtnText: "Ok",
              popupOutlinebtnOnclick: popupOutlinebtnOnclick,
              isSingleConfirmationBtn: true,
            });
          } 
    } else {
      let decriptionTxt = (
        <p>Please Select atleast one catalog item to add.</p>
      );
      setPopupcontent({
        ...Popupcontent,
        titleImg: ConfirmationBee,
        title: "INFORMATION",
        isDialogVisible: true,
        isTitleWarning: false,
        subtextcontent: decriptionTxt,
        outlineBtnText: "Ok",
        popupOutlinebtnOnclick: popupOutlinebtnOnclick,
        isSingleConfirmationBtn: true,
      });  
  }
}

const cancelEditRequestType = () => {
  dispatch(RequisitionAction.setIsEditRequestClick(false))
  dispatch(RequisitionAction.setEditRequestDetails({}))
  // dispatch(RequisitionAction.setIsAddRequistionTypeClick(true))
}

  const popupOutlinebtnOnclick = () => {
    hideDialog();
  };

  const hideDialog = () => {
    setPopupcontent({ ...Popupcontent, isDialogVisible: false })
  };

  return (
    <CatalogItem
      catalogItemDetails={catalogItemDetailsTemp}
      quantityIncrement={quantityIncrement}
      quantityDecrement={quantityDecrement}
      quantityOnChange={quantityOnChange}
      addNewItemClick={addNewItemClick}
      handleCardClick={handleCardClick}
      Popupcontent={Popupcontent}
      hideDialog={hideDialog}
      isCatalogItemExist = {isCatalogItemExist}
      isEditRequestClick={isEditRequestClick}
      updateItemClick={updateItemClick}
      cancelEditRequestType={cancelEditRequestType}
    />
  )
}
export default CatalogItemContainer;